module.exports = {};



//////////////////
// WEBPACK FOOTER
// D:/NOWFLOATS/ana-web-chat-master-f726fd66c7ed228fb0b4a1e0e71ea760bd266a85/node_modules/core-js/modules/_iterators.js
// module id = ../../../../core-js/modules/_iterators.js
// module chunks = polyfills